import {Dispatch, FC, useState, createContext, useContext} from 'react'
import {WithChildren} from '../../_metronic/helpers'

type StateContextProps = {
  progressId: number
  setProgressId: Dispatch<React.SetStateAction<number>>
}

const initStateContextPropsState = {
  progressId: 0,
  setProgressId: () => {},
}

const StateContext = createContext<StateContextProps>(initStateContextPropsState)

const useStateContext = () => {
  return useContext(StateContext)
}

const StateProvider: FC<WithChildren> = ({children}) => {
  const [progressId, setProgressId] = useState<number>(0)

  return (
    <StateContext.Provider value={{progressId, setProgressId}}>{children}</StateContext.Provider>
  )
}

export {useStateContext, StateProvider}
